import { useMemo } from 'react';
import { useI18n } from '../I18nContext';
import type { ProMessages } from './types';
import { proFr } from './fr';
import { proEn } from './en';

const byLocale: Partial<Record<string, ProMessages>> = { fr: proFr, en: proEn };

/** Libellés de la formule Pro pour la langue courante (repli anglais tant qu'une langue n'est pas traduite). */
export function useProMessages(): ProMessages {
  const { locale } = useI18n();
  return useMemo(() => byLocale[locale] || proEn, [locale]);
}

export type { ProMessages } from './types';
export { proFr, proEn };
